module.exports = __webpack_public_path__ + "static/media/crsp.fb812a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/crsp.png
// module id = 482
// module chunks = 0